import { l as spot } from '../lib/imports'
import { IOxygenModel } from './oxygenModel'
import { oxygenModel } from './oxygenModel-sidecar'
import { assert } from '../lib/assert-sidecar'

export function run(model: IOxygenModel) {
  spot.forEach(model.actors, (c) => {
    let spot = oxygenModel.getTileUnsafe(model, c.i, c.j)

    if (c.type === 'o2gen') {
      assert.notNil(c.setPoint)
      if (spot.o2 < c.setPoint) {
        spot.o2 += 25
      }
    }

    if (c.type === 'co2scrubber') {
      spot.co2 -= 5
    }

    if (c.type === 'human') {
      spot.co2 += 1
      spot.o2 -= 1
    }
  })

  let numSpaces = 0
  let numLeaks = 0
  let o2diff = 0

  const processSpace = (
    curSpot: oxygenModel.IModelSpot,
    spot: oxygenModel.IModelSpot | null,
  ) => {
    if (spot && !spot.isHull) {
      if (spot.o2 < curSpot.o2) {
        o2diff += curSpot.o2 - spot.o2
        numSpaces++
      }
      if (spot.isSpace) {
        numLeaks++
      }
    }
  }
  const updateSpace = (
    curSpot: oxygenModel.IModelSpot,
    spot: oxygenModel.IModelSpot | null,
    scale: number,
  ) => {
    if (spot && !spot.isSpace && !spot.isHull) {
      if (spot.o2 < curSpot.o2) {
        let diff = curSpot.o2 - spot.o2
        spot.o2next += diff * scale
      }
    }
  }

  spot.forEach(model.spots, (c) => {
    if (c.isSpace || c.isHull) {
      c.co2next = 0
      c.o2next = 0
    } else {
      let l = oxygenModel.getTile(model, c.i - 1, c.j)
      let r = oxygenModel.getTile(model, c.i + 1, c.j)
      let t = oxygenModel.getTile(model, c.i, c.j - 1)
      let b = oxygenModel.getTile(model, c.i, c.j + 1)

      numSpaces = 0
      numLeaks = 0
      o2diff = 0

      processSpace(c, l)
      processSpace(c, r)
      processSpace(c, t)
      processSpace(c, b)

      if (numLeaks > 0) {
        c.o2next = 0
        c.co2next = 0
      } else {
        c.o2next += c.o2
        c.co2next += c.co2
        if (numSpaces > 0) {
          const scale = 0.2

          let o2diffAdj = o2diff * scale
          c.o2next -= o2diffAdj

          updateSpace(c, l, scale)
          updateSpace(c, r, scale)
          updateSpace(c, t, scale)
          updateSpace(c, b, scale)
        }
      }
    }
  })

  spot.forEach(model.spots, (c) => {
    c.o2 = c.o2next
    c.co2 = c.co2next
    c.o2next = 0
    c.co2next = 0

    // Limit
    if (c.o2 > 300) {
      c.o2 = 300
    }
    if (c.o2 < 0) {
      c.o2 = 0
    }
    if (c.co2 > 300) {
      c.co2 = 300
    }
    if (c.co2 < 0) {
      c.co2 = 0
    }
  })
}
